'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var View = require('./view.js')

var EventsList = function (options) {
  var Controller = Marionette.Object.extend({
    initialize: function (options) {
      var self = this
      this.region = options.region
      var device = options.device
      self.device = device
      self.layout = self.getLayoutView(device)

      //
      self.events = App.globalChannel.request('event:entities', {query: {device: self.device.get('_id'), '$sort': '-createdAt'}})

      this.listenTo(self.events, 'request sync', function () {})
      this.listenTo(self.layout, 'render', self.timelineRegion)
      this.listenTo(self.layout, 'timeline:next', () => { self.events.getNextPage() })

      self.region.show(self.layout)
    },

    /* Event methods --------------------------------------------------------- */
    /* Regions --------------------------------------------------------------- */
    timelineRegion: function () {
      var self = this

      var emptyViewModel = new Backbone.Model({
        title: 'No events yet.',
        subTitle: 'events will appear automatically'
      })

      var timelineView = self.getTimelineView(self.events.fullCollection, emptyViewModel)

      self.layout.showChildView('timelineRegion', timelineView)
    },
    /* Views ----------------------------------------------------------------- */
    getTimelineView: function (schedules, model) {
      return new View.TimelineView({collection: schedules, model: model})
    },
    getLayoutView: function (device) {
      return new View.Layout({model: device})
    }
  })

  return new Controller(options)
}

module.exports = EventsList



// WEBPACK FOOTER //
// ./js/modules/device-events/show/index.js